import Vue from 'vue';
import Router from 'vue-router';

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: 'face'
        },
        {
            path: '*',
            component: () => import('../components/page/404.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/home',
            component: () => import('../components/common/Home.vue'),
            meta: {
                title: '业务领域'
            },
            children: [

                {
                    path: '/businessArea/operation',
                    component: () =>
                        import('../components/page/businessArea/operation.vue'),
                    meta: {
                        title: '工程案例'
                    }
                },
                {
                    path: '/businessArea/product',
                    component: () =>
                        import('../components/page/businessArea/product.vue'),
                    meta: {
                        title: '产品中心'
                    }
                }

            ]
        },
        {
            path: '/home',
            component: () => import('../components/common/Home.vue'),
            meta: {
                title: '新闻资讯'
            },
            children: [
                // 新闻资讯
                {
                    path: '/newsInformation',
                    component: () => import('../components/page/news/newsInformation.vue'),
                    meta: {
                        title: '新闻资讯'
                    }
                },
                {
                    path: '/classNewsList',
                    component: () => import('../components/page/news/classNewsList.vue'),
                    meta: {
                        title: '新闻列表'
                    }
                },
                {
                    path: '/articleInfo',
                    component: () => import('../components/page/news/articleInfo.vue'),
                    meta: {
                        title: '文章'
                    }
                }
            ]
        },
    
        {
            path: '/home',
            component: () => import('../components/common/Home.vue'),
            children: [
                {
                    path: '/face',
                    component: () => import('../components/page/face.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/operation',
                    component: () => import('../components/page/operation.vue'),
                    meta: {
                        title: '工程案例'
                    }
                },
                {
                    path: '/operationDetails',
                    component: () => import('../components/page/operationDetails.vue'),
                    meta: {
                        title: '工程案例详情'
                    }
                },
                {
                    path: '/product',
                    component: () => import('../components/page/product.vue'),
                    meta: {
                        title: '产品中心'
                    }
                },
                {
                    path: '/productDetails',
                    component: () => import('../components/page/productDetails.vue'),
                    meta: {
                        title: '产品中心详情'
                    }
                },
                // 关于我们
                {
                    path: '/aboutUs',
                    component: () => import('../components/page/aboutUs.vue'),
                    meta: {
                        title: '关于我们'
                    }
                }
            ]
        }
    ],
    //对于所有路由导航，简单地让页面滚动到顶部。    
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
});